<template>
	<div class="main-container">
		<div class="mobile-screen">
			<div class="mobile-wiink">
				<img class="mobile-image" src="@/assets/winkyLogo/wiink-mobile.png" />
			</div>
			<div class="mobile-text">
				<h3 class="mobile-title">
					{{ $t('mobile_layout.title') }}
				</h3>
			</div>

			<div class="mobile-picto">
				<img src="@/assets/logo/phone.svg?url" />
				<img class="picto" src="@/assets/logo/arrow.svg?url" />
				<img src="@/assets/logo/computer.svg?url" />
			</div>
		</div>

		<div class="desktop-app">
			<slot />
		</div>
	</div>
</template>
<style>
.main-container {
	height: auto;
	width: 100%;
	margin: 0;
}

.mobile-screen {
	display: none;
	flex-direction: column;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-image: url('../assets/background/line.svg');
	background-repeat: no-repeat;
	background-position: bottom;
}

.mobile-image {
	width: 201px;
	height: 204px;
}

.mobile-wiink {
	display: flex;
	margin-top: 10%;
	justify-content: center;
}

.mobile-text {
	display: flex;
	margin-top: 12%;
	justify-content: center;
}

.mobile-title {
	font-weight: 600;
	color: #000000;
	width: 301px;
	text-align: center;
	font-size: 20px;
	line-height: 28px;
}

@media screen and (max-width: 770px) {
	.mobile-screen {
		display: flex;
	}

	.desktop-app {
		display: none;
	}
}

.blue-container {
	display: flex;
	background-color: #130e4b;
	height: 100%;
	width: 90%;
	-webkit-box-shadow: 4px 0px 14px 0px rgba(0, 0, 0, 0.3);
	-moz-box-shadow: 4px 0px 14px 0px rgba(0, 0, 0, 0.3);
	box-shadow: 4px 0px 14px 0px rgba(0, 0, 0, 0.3);
}

.baseline {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.baseline-text {
	color: #fff;
	font-size: 25px;
	text-align: center;
	padding-top: 50px;
}

.mobile-picto {
	display: flex;
	justify-items: center;
	justify-content: center;
	margin-top: 47px;
}
</style>
